import SuppliersDataGrid from './SuppliersDataGrid'
export default SuppliersDataGrid
